define([
	"dojo/_base/declare",
	"csi/action/_NewCommentMixin",
	"csi/gallery/New"
], function(declare,_NewCommentMixin,New) {

	return declare([New, _NewCommentMixin], {
		preProcess: function() {
			this.edit(this.getTitle());
		},

		preProcessContinue: function() {
			New.prototype.preProcess.call(this);
		},

		toWriter: function() {
			this.inherited(arguments);
			this.toWriterComment();
		},

		postProcessSuccess: function() {
			return this.widget.addBlocks([this.getNode()], this.refNode, true);
		}
	});
});